import { useRoles } from '@utils/hooks/use-roles';
import { ActingAsBanner as SharedActingAsBanner } from '@components/shared/acting-as-banner/acting-as-banner';

// SYSOP back-office variant of the impersonation banner. Reseller surface
// mounts its own ResellerActingAsBanner instance.
export default function ActingAsBanner() {
  const { isSysOp } = useRoles();
  return (
    <SharedActingAsBanner
      enabled={!!isSysOp}
      homeOrgKeyPrefix="sysop"
      backLink="/back-office/customers"
    />
  );
}
